import { Box } from '@mui/material';
import React from 'react';
// import backgroundImage from "../../images/backgroundimg.png";
// import Navbar from '../PrivacyPolicy/Navbar';
import FooterSection from '../Footer/FooterSection';
import ContactUsForm from '../Footer/FooterContactPopup';
function Contact() {
  return (
    <div>
      <Box>
        {/* <Navbar
          pageName={{
            navbarName: "CONTACT US",
            backimg: backgroundImage,
          }}
        /> */}
      </Box>
      <ContactUsForm/>
      <FooterSection />
    </div>
  )
}

export default Contact
